import { Highlight, HighlightOff } from '@mui/icons-material';
import { Fab } from '@mui/material';

function FlashScannerButton({ isFlashOn, handleFlash }) {
  return (
    <Fab color="primary" onClick={handleFlash} size="small">
      {isFlashOn ? <HighlightOff /> : <Highlight />}
    </Fab>
  );
}

export { FlashScannerButton };
